export default __webpack_public_path__ + "static/media/dm_hang_san_xuat.e534f7df.xlsx";